var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBankCheck(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "420px",
    height: "522px",
    viewBox: "0 0 420 522",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "illustration/Illustration_EB_07") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "-43.1078645%",
    y1: "59.4169135%",
    x2: "99.9993675%",
    y2: "49.9980402%",
    id: "linearGradient-1"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DCDCDD",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DFDFE0",
    offset: "38.85%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EAEAEB",
    offset: "60.2894%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F9F9F9",
    stopOpacity: 0.24,
    offset: "97.627%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "100.001095%",
    y1: "50.0049539%",
    x2: "-0.000631845819%",
    y2: "50.0049539%",
    id: "linearGradient-2"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BDBEBF",
    offset: "39.62%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F8F8F8",
    offset: "60.76%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "-0.000343547289%",
    y1: "50%",
    x2: "100.000979%",
    y2: "50%",
    id: "linearGradient-3"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFFFFF",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F5F5F5",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "49.8821139%",
    y1: "97.0287247%",
    x2: "50.9222856%",
    y2: "-42.7129649%",
    id: "linearGradient-4"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00B4E6",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00B4E6",
    stopOpacity: 0,
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "-0.000515197972%",
    y1: "49.9828031%",
    x2: "99.994112%",
    y2: "49.9828031%",
    id: "linearGradient-5"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F8F8F8",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DDDEDE",
    stopOpacity: 0.41,
    offset: "57.2917%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DDDEDE",
    stopOpacity: 0.12,
    offset: "100%"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "illustration/Illustration_EB_07",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Illustration_EB_07",
    transform: "translate(0, 71)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M239.991387,163.096486 L182.727175,163.096486 L351.748641,261.939332 C359.371865,266.398103 359.371865,277.545031 351.748641,282.013935 L182.727175,380.856782 L239.991387,380.856782 C245.573748,380.856782 251.046062,379.367147 255.878105,376.539881 L412.654394,284.861469 C422.448535,279.136001 422.448535,264.817266 412.654394,259.091799 L255.878105,167.413387 C251.056066,164.575987 245.573748,163.096486 239.991387,163.096486 Z",
    id: "Path",
    fill: "url(#linearGradient-1)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365.41442,273.988148 C365.124297,269.529377 361.792888,264.898335 355.540245,261.240116 L204.346316,172.905782 C192.381257,165.913619 174.283604,165.163734 163.919222,171.223609 L6.98289514,263.094559 C2.04080549,265.99276 -0.240156959,269.914452 0.0199530226,273.988148 C0.310075694,278.446919 3.6414823,283.07796 9.89412609,286.736179 L161.088025,375.070513 C174.393651,382.842961 192.491303,382.032276 201.515119,376.752686 L358.451476,284.881736 C363.403569,281.993668 365.684534,278.061843 365.41442,273.988148 Z",
    id: "Path",
    fill: "#EEEEEE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365.41442,270.684604 L365.434428,270.67447 L365.434428,255.484248 L304.078485,285.682288 L204.346316,227.414258 C192.381257,220.422094 174.283604,219.67221 163.919222,225.732085 L61.4458936,285.722822 L0.0198919967,255.484248 L0.0198919967,269.53951 C-0.000116763499,269.914452 -0.000116763499,270.289394 0.0198919967,270.664336 C0.310014668,275.123107 3.64142228,279.754149 9.89406607,283.412368 L161.088025,371.746702 C167.290648,375.37452 175.153972,377.320166 182.727175,377.50257 C189.750144,377.674841 196.533012,376.347343 201.515119,373.428875 L358.451476,281.557925 C363.393565,278.679991 365.67453,274.758299 365.41442,270.684604 Z",
    id: "Path",
    fill: "url(#linearGradient-2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365.41442,255.484248 C365.124297,251.025477 361.792888,246.394435 355.540245,242.736216 L204.346316,154.401883 C192.381257,147.409719 174.283604,146.659835 163.919222,152.71971 L6.98289514,244.59066 C2.04080549,247.488861 -0.240156959,251.410553 0.0199530226,255.484248 C0.310075694,259.943019 3.6414823,264.574061 9.89412609,268.23228 L161.088025,356.566613 C173.053084,363.558777 191.150736,364.308661 201.515119,358.248786 L358.451476,266.377836 C363.403569,263.489769 365.684534,259.557943 365.41442,255.484248 Z",
    id: "Path",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365.41442,253.417 C365.124297,248.958229 361.792888,244.327187 355.540245,240.668968 L204.346316,152.334634 C192.381257,145.342471 174.283604,144.592586 163.919222,150.652461 L6.98289514,242.523411 C2.04080549,245.421612 -0.240156959,249.343304 0.0199530226,253.417 C0.310075694,257.875771 3.6414823,262.506812 9.89412609,266.165031 L161.088025,354.499365 C173.053084,361.491529 191.150736,362.241413 201.515119,356.181538 L358.451476,264.310588 C363.403569,261.42252 365.684534,257.490695 365.41442,253.417 Z",
    id: "Path",
    fill: "url(#linearGradient-3)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M325.737643,108.182668 L325.737643,258.55472 C325.737643,263.033758 320.945617,265.840757 317.113997,263.601238 L162.348558,173.088186 C156.396041,169.602238 152.724489,163.177555 152.724489,156.215792 L152.724489,5.83360596 C152.724489,1.35456782 157.516515,-1.4524312 161.348135,0.78708787 L316.113574,91.3001392 C322.076095,94.7860875 325.737643,101.210771 325.737643,108.182668 Z",
    id: "Path",
    fill: "#FFFAFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M321.695934,110.624858 L321.695934,260.99691 C321.695934,265.475948 316.903908,268.282947 313.072288,266.043428 L158.306849,175.530377 C152.354332,172.044429 148.68278,165.619745 148.68278,158.657982 L148.68278,8.28593001 C148.68278,3.80689187 153.474806,0.99989285 157.306426,3.23941192 L312.071865,93.7524633 C318.034386,97.228278 321.695934,103.663095 321.695934,110.624858 Z",
    id: "Path",
    fill: "#003DCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306.09934,283.341433 C306.439484,283.341433 306.779627,283.159029 306.969708,282.834755 C307.249826,282.348343 307.089758,281.730195 306.609555,281.446455 L163.198918,198.128239 C162.718714,197.844499 162.108456,198.006636 161.828338,198.493048 C161.54822,198.979459 161.708287,199.597607 162.18849,199.881347 L305.599128,283.199563 C305.749192,283.300899 305.929268,283.341433 306.09934,283.341433 Z",
    id: "Path",
    fill: "#00BFE9"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "url(#linearGradient-4)",
    points: "163.729142 198.695719 306.629564 282.855022 306.629564 223.462165 163.729142 139.272462"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#FFFFFF",
    points: "279.818227 182.907616 283.019581 184.772193 283.019581 181.043039 279.818227 179.178462"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#FFFFFF",
    points: "288.081721 187.741329 291.273071 189.605906 291.273071 185.866619 288.081721 184.002042"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#00BFE9",
    points: "296.335211 192.564909 299.526561 194.429486 299.526561 190.700332 296.335211 188.835755"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#00BFE9",
    points: "304.588701 197.388488 307.78005 199.263199 307.78005 195.523911 304.588701 193.659334"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#FFFFFF",
    points: "255.057758 178.033369 258.249107 179.897946 258.249107 176.168792 255.057758 174.304215"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#FFFFFF",
    points: "263.311248 182.867082 266.502597 184.731659 266.502597 180.992371 263.311248 179.127794"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#FFFFFF",
    points: "271.564738 187.690661 274.756087 189.555238 274.756087 185.826085 271.564738 183.961508"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#FFFFFF",
    points: "279.818227 192.524375 283.019581 194.388952 283.019581 190.649664 279.818227 188.785087"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#FFFFFF",
    points: "288.081721 197.347954 291.273071 199.212531 291.273071 195.483377 288.081721 193.6188"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#00BFE9",
    points: "296.335211 202.171534 299.526561 204.046244 299.526561 200.306957 296.335211 198.44238"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#00BFE9",
    points: "304.588701 207.005247 307.78005 208.869824 307.78005 205.14067 304.588701 203.265959"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#FFFFFF",
    points: "255.057758 187.650127 258.249107 189.514704 258.249107 185.775417 255.057758 183.91084"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#FFFFFF",
    points: "263.311248 192.473707 266.502597 194.338284 266.502597 190.60913 263.311248 188.744553"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#FFFFFF",
    points: "271.564738 197.297286 274.756087 199.171997 274.756087 195.432709 271.564738 193.568132"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#FFFFFF",
    points: "279.818227 202.130999 283.019581 203.995576 283.019581 200.266422 279.818227 198.391712"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#FFFFFF",
    points: "288.081721 206.954579 291.273071 208.829289 291.273071 205.090002 288.081721 203.225425"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#00BFE9",
    points: "296.335211 211.788292 299.526561 213.652869 299.526561 209.923715 296.335211 208.049005"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#00BFE9",
    points: "304.588701 216.611872 307.78005 218.476449 307.78005 214.747295 304.588701 212.882718"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#FFFFFF",
    points: "255.057758 197.256752 258.249107 199.121329 258.249107 195.392175 255.057758 193.527598"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#FFFFFF",
    points: "263.311248 202.080332 266.502597 203.955042 266.502597 200.215755 263.311248 198.351178"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#FFFFFF",
    points: "271.564738 206.914045 274.756087 208.778622 274.756087 205.049468 271.564738 203.174757"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#FFFFFF",
    points: "279.818227 211.737624 283.019581 213.602201 283.019581 209.873047 279.818227 208.00847"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#FFFFFF",
    points: "288.081721 216.571337 291.273071 218.435914 291.273071 214.70676 288.081721 212.83205"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#00BFE9",
    points: "296.335211 221.394917 299.526561 223.259494 299.526561 219.53034 296.335211 217.665763"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#00BFE9",
    points: "304.588701 226.22863 307.78005 228.093207 307.78005 224.353919 304.588701 222.489342"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#FFFFFF",
    points: "255.057758 206.863377 258.249107 208.738087 258.249107 204.9988 255.057758 203.134223"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#FFFFFF",
    points: "263.311248 211.69709 266.502597 213.561667 266.502597 209.832513 263.311248 207.957802"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#FFFFFF",
    points: "271.564738 216.520669 274.756087 218.385246 274.756087 214.656092 271.564738 212.791516"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#FFFFFF",
    points: "288.081721 226.177962 291.273071 228.042539 291.273071 224.313385 288.081721 222.448808"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.689125,84.1965064 C163.529057,84.1965064 163.409006,84.0647699 163.409006,83.9127664 L163.409006,64.8211196 C163.409006,64.6589825 163.539061,64.5373797 163.689125,64.5373797 C163.849192,64.5373797 163.969243,64.6691161 163.969243,64.8211196 L163.969243,83.9127664 C163.979247,84.0647699 163.849192,84.1965064 163.689125,84.1965064 Z",
    id: "Path",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.229078,97.957895 C187.06901,97.957895 186.94896,97.8261586 186.94896,97.6741551 L186.94896,50.9583952 C186.94896,50.7962581 187.079015,50.6746553 187.229078,50.6746553 C187.389146,50.6746553 187.509197,50.8063917 187.509197,50.9583952 L187.509197,97.6741551 C187.509197,97.8261586 187.379142,97.957895 187.229078,97.957895 Z",
    id: "Path",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#FFFFFF",
    points: "191.120724 105.740477 183.337433 101.190504 183.337433 104.970326 191.120724 109.520299"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#FFFFFF",
    points: "167.180601 91.7460163 159.39731 87.1960432 159.39731 90.9657314 167.180601 95.5157046"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.759027,111.719284 C210.59896,111.719284 210.478909,111.587547 210.478909,111.435544 L210.478909,92.343897 C210.478909,92.1817599 210.608964,92.060157 210.759027,92.060157 C210.919095,92.060157 211.039146,92.1918934 211.039146,92.343897 L211.039146,111.435544 C211.039146,111.587547 210.919095,111.719284 210.759027,111.719284 Z",
    id: "Path",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#FFFFFF",
    points: "214.650673 119.501866 206.867382 114.951893 206.867382 118.731714 214.650673 123.281688"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234.288976,125.399604 C234.128909,125.399604 234.008858,125.267867 234.008858,125.115864 L234.008858,78.400104 C234.008858,78.2379669 234.138913,78.1163641 234.288976,78.1163641 C234.449044,78.1163641 234.569095,78.2481005 234.569095,78.400104 L234.569095,125.115864 C234.579099,125.267867 234.449044,125.399604 234.288976,125.399604 Z",
    id: "Path",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#FFFFFF",
    points: "238.180622 133.263255 230.397331 128.713281 230.397331 132.493103 238.180622 137.043076"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.82893,139.160993 C257.668862,139.160993 257.548811,139.029256 257.548811,138.877253 L257.548811,119.785606 C257.548811,119.623469 257.678866,119.501866 257.82893,119.501866 C257.978993,119.501866 258.109048,119.633602 258.109048,119.785606 L258.109048,138.877253 C258.109048,139.029256 257.978993,139.160993 257.82893,139.160993 Z",
    id: "Path",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#FFFFFF",
    points: "261.710571 147.024643 253.937284 142.47467 253.937284 146.254492 261.710571 150.804465"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281.358879,152.922381 C281.198811,152.922381 281.07876,152.790645 281.07876,152.638641 L281.07876,105.922881 C281.07876,105.760744 281.208815,105.639141 281.358879,105.639141 C281.518946,105.639141 281.638997,105.770878 281.638997,105.922881 L281.638997,152.638641 C281.638997,152.790645 281.508942,152.922381 281.358879,152.922381 Z",
    id: "Path",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#FFFFFF",
    points: "285.250524 160.796165 277.467233 156.246192 277.467233 160.015881 285.250524 164.565854"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304.888828,166.68377 C304.72876,166.68377 304.608709,166.552034 304.608709,166.40003 L304.608709,147.308383 C304.608709,147.146246 304.738764,147.024643 304.888828,147.024643 C305.048896,147.024643 305.168946,147.15638 305.168946,147.308383 L305.168946,166.40003 C305.168946,166.552034 305.048896,166.68377 304.888828,166.68377 Z",
    id: "Path",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#FFFFFF",
    points: "308.780473 174.557554 300.997182 170.007581 300.997182 173.777269 308.780473 178.327242"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.007145,69.0772192 C158.536946,68.8036128 158.156786,68.1347972 158.156786,67.5774508 C158.156786,67.0201044 158.536946,66.7971659 159.007145,67.0707723 L163.699129,69.7967027 C163.719137,69.8068363 163.739146,69.8169699 163.759154,69.837237 C166.920491,71.6916804 170.552027,69.1278871 174.063511,66.6552959 C178.215267,63.7368276 182.497077,60.7170236 187.219074,63.3922862 C187.259091,63.4125533 187.309112,63.442954 187.349129,63.4632212 C191.861037,66.0979495 195.792699,72.4719653 199.594306,78.6331762 C203.165817,84.4295785 206.867382,90.4185186 210.759027,92.698572 C214.250504,94.7455532 217.48187,88.7363459 220.60319,82.92981 C224.444814,75.7856429 228.406489,68.3881364 234.298981,71.8335504 C240.051413,75.1978958 243.903041,84.9058563 247.624615,94.2895425 C250.885994,102.528135 253.977301,110.310717 257.778909,112.540103 C257.798917,112.550237 257.808921,112.56037 257.82893,112.570504 C262.310825,115.134297 266.102428,116.259123 269.77398,117.353549 C273.335486,118.40744 277.017043,119.501866 281.33887,121.883255 C285.840774,124.355846 289.392276,129.230093 292.823726,133.93207 C296.325207,138.725249 299.946738,143.690699 304.758773,146.497698 C304.79879,146.517965 304.838807,146.548365 304.888828,146.568633 L313.212347,151.44288 C313.682546,151.716486 314.062707,152.385302 314.062707,152.942648 C314.062707,153.489861 313.682546,153.722933 313.212347,153.439193 L304.888828,148.57508 C304.838807,148.544679 304.788786,148.514278 304.738764,148.494011 C299.426518,145.383005 295.584894,140.123682 291.86332,135.036629 C288.501899,130.435988 285.320554,126.088687 281.378887,123.909969 C277.237136,121.629916 273.805685,120.606425 270.17415,119.532267 C266.412559,118.417574 262.510909,117.262347 257.838934,114.576951 C257.818925,114.566817 257.798917,114.556683 257.768904,114.536416 C252.996887,111.749684 249.675482,103.359088 246.153993,94.4719468 C242.682525,85.7064084 239.081003,76.6368628 234.298981,73.8399973 C229.486946,71.0228648 225.585296,78.2886348 222.143841,84.7031849 C218.642361,91.2292043 215.33096,97.3802815 210.759027,94.7050189 C206.217107,92.0500235 202.27544,85.6557405 198.463828,79.4843961 C194.732251,73.4447881 191.210762,67.7395879 187.349129,65.4798017 C187.309112,65.4595346 187.279099,65.4392674 187.239082,65.4190003 C183.267403,63.1693476 179.225694,66.0067474 175.324044,68.752945 C171.392382,71.5194097 167.670808,74.1440045 163.769159,71.8639511 C163.739146,71.843684 163.709133,71.8234168 163.679121,71.8132832 L159.007145,69.0772192 Z",
    id: "Path",
    fill: "#00BFE9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.28445,124.325445 C166.960508,118.873584 159.39731,123.291821 159.39731,134.205677 C159.39731,145.109398 166.960508,158.374242 176.28445,163.826103 C185.608393,169.277964 193.171591,164.859727 193.171591,153.945872 C193.171591,143.04215 185.608393,129.777306 176.28445,124.325445 Z M176.28445,159.205195 C169.14143,155.030164 163.348981,144.866193 163.348981,136.516131 C163.348981,128.166069 169.14143,124.781456 176.28445,128.956487 C183.427471,133.131518 189.21992,143.295489 189.21992,151.645551 C189.21992,159.995613 183.427471,163.380226 176.28445,159.205195 Z",
    id: "Shape",
    fill: "#00BFE9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226.035487,153.418926 C216.711544,147.967065 209.148346,152.385302 209.148346,163.299157 C209.148346,174.213013 216.711544,187.467723 226.035487,192.919584 C235.359429,198.371445 242.922627,193.953208 242.922627,183.039353 C242.922627,172.135631 235.359429,158.870787 226.035487,153.418926 Z M226.035487,188.298676 C218.892466,184.123645 213.100017,173.959674 213.100017,165.609611 C213.100017,157.259549 218.892466,153.874937 226.035487,158.049968 C233.178507,162.224999 238.970956,172.38897 238.970956,180.739032 C238.960952,189.089094 233.178507,192.473707 226.035487,188.298676 Z",
    id: "Shape",
    fill: "#00BFE9"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#00BFE9",
    points: "232.918397 66.2499531 234.008858 70.0297748 235.099319 67.5267829 237.900503 69.1582878 237.900503 62.7944055 230.117212 58.2444324 230.117212 64.6083146"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.958964,141.795721 L190.220343,141.096505 C187.179057,134.124608 182.066895,127.720191 176.28445,124.335579 L176.28445,128.956487 C180.726329,131.550681 184.637983,136.445196 186.958964,141.795721 Z",
    id: "Path",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.960952,180.739032 C238.960952,184.235114 237.94052,186.849575 236.229797,188.410145 L239.351117,193.071587 C241.572056,191.024606 242.912623,187.619727 242.912623,183.049486 C242.912623,172.145764 235.349425,158.880921 226.025482,153.42906 L226.025482,158.049968 C233.178507,162.224999 238.960952,172.378837 238.960952,180.739032 Z",
    id: "Path",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.402788,244.256252 C89.0674727,244.256252 79.0632427,249.535842 79.0632427,256.041594 C79.0632427,262.547347 89.0674727,267.826937 101.402788,267.826937 L214.990817,267.826937 L214.990817,244.256252 L101.402788,244.256252 Z",
    id: "Path",
    fill: "url(#linearGradient-5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.2209202,259.385673 C100.572437,262.233206 101.272733,261.949466 101.702915,263.925512 C102.133097,265.901558 96.7707299,264.715931 94.2296554,263.763375 C94.2296554,263.763375 92.1587798,262.962823 91.0983314,261.56439 C90.0478873,260.165957 88.9874389,260.865174 86.9965971,260.165957 C85.0057553,259.466741 84.7656538,257.521096 85.6260176,254.450624 C86.4963856,251.380152 92.2788306,254.399956 93.5193551,255.382912 C94.7898923,256.365869 97.2209202,259.385673 97.2209202,259.385673 Z",
    id: "Path",
    fill: "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.9704915,95.7589103 C97.0509484,93.3876548 98.1514137,94.9482246 98.731659,92.0398899 C99.3119044,89.1214216 98.1614179,85.290932 94.0096624,82.5143337 C89.857907,79.7377353 87.206786,83.0615465 86.7465914,87.9661946 C86.2863968,92.8708427 89.1075897,96.4783938 89.1075897,96.4783938 L93.0092394,97.8261586 L95.9704915,95.7589103 Z",
    id: "Path",
    fill: "#FFBB83"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.923854,173.513796 C101.552852,190.517928 98.9817648,198.634918 97.7212318,211.616021 C96.4606988,224.597125 94.8100008,244.965602 93.2793536,252.474577 C92.2589222,257.480561 85.4960626,256.963749 85.9262445,252.474577 C86.336418,248.218478 85.0558765,218.658853 84.1054747,210.84587 C83.1450686,203.032887 81.6544383,169.4097 81.6544383,169.4097 L103.293588,152.121829 L103.923854,173.513796 Z",
    id: "Path",
    fill: "#003DCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.457886,250.427596 C116.809303,253.27513 117.509599,252.99139 117.939781,254.967436 C118.369963,256.943482 113.007695,255.757854 110.466621,254.805299 C110.466621,254.805299 108.395745,254.004747 107.335297,252.616447 C106.284853,251.218015 105.224404,251.917231 103.233563,251.218015 C101.242721,250.518798 101.002619,248.573153 101.862983,245.502681 C102.733351,242.432209 108.515796,245.452013 109.756321,246.434969 C111.016854,247.417926 113.457886,250.427596 113.457886,250.427596 Z",
    id: "Path",
    fill: "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.106892,174.111677 C116.06899,191.115808 115.208626,189.676841 113.948093,202.657945 C112.68756,215.639049 111.036862,236.007525 109.506215,243.516501 C108.485783,248.522485 101.722924,248.005673 102.153106,243.516501 C102.563279,239.260402 101.282738,209.700777 100.332336,201.887794 C99.3718297,194.074811 97.8811994,160.451624 97.8811994,160.451624 L103.923854,147.389452 L111.106892,174.111677 Z",
    id: "Path",
    fill: "#003DCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.2012347,87.3480468 C96.6005579,87.7837903 96.3205395,88.5235409 95.5001927,89.2835587 C94.6998543,90.0233094 93.9594412,90.6718579 93.2191282,90.1550458 C91.7885233,89.1619559 92.168684,88.1992667 91.4483794,87.3480468 C90.7280749,86.4968268 90.648041,86.588029 91.1982737,85.7165419 C91.7485063,84.8450549 92.0687418,84.9261234 93.1792113,84.936257 C94.1496216,84.9463906 95.6601603,84.581582 96.2704183,84.3991778 L96.6505791,84.8247877 C96.6505791,84.8247877 98.731559,82.5954022 96.7507214,80.9334967 C94.7598796,79.2715911 91.1182399,78.8459811 89.0173515,80.4572189 C89.0173515,80.4572189 86.4462644,79.9404068 84.9356257,83.8620985 C83.4249869,87.7837903 87.2766155,94.6543511 88.3370639,95.2116974 C89.1574108,95.647441 89.8477026,95.2623653 90.2178591,93.6713947 C90.5880157,92.0804242 90.7181707,91.2089371 89.81779,90.6819914 C88.9174093,90.1550458 88.4871273,88.4830067 89.4675419,88.1080646 C90.4379522,87.7331224 90.818213,87.8749924 91.3584414,88.7363459 C91.9086741,89.607833 92.7989505,93.6308605 93.5492678,94.2895425 C94.299585,94.9482246 95.9003619,93.7220626 97.1809033,93.6612612 C97.6711106,93.640994 98.1112967,93.6713947 98.1112967,93.6713947 C100.722501,93.3065862 100.042213,86.8413682 98.2012347,87.3480468 Z",
    id: "Path",
    fill: "#4F4E51"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.8917267,95.647441 C98.5515829,95.2724989 97.2410287,96.3770581 96.0005042,93.7321962 C95.7003773,93.0937812 93.1492986,93.8436654 92.7391252,93.2660519 C92.3289518,92.6884384 97.3809879,92.2324277 98.8416055,91.6852149 C100.302323,91.1278686 98.731659,89.0302195 99.2418747,88.6046095 C99.7520905,88.168866 100.952598,90.9353307 101.142678,92.1513592 C101.322755,93.3673876 101.692911,94.5327482 101.692911,94.5327482 C101.692911,94.5327482 102.013046,99.0928549 98.8917267,95.647441 Z",
    id: "Path",
    fill: "#FFBB83"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.2125602,109.72297 L84.0954704,105.132463 C87.686989,97.6842886 96.9709145,99.467797 98.0613756,100.775028 C105.614569,102.274796 107.535381,105.943149 109.996422,108.669079 C109.996422,108.669079 102.553275,103.521225 99.9621793,97.4613501 C99.3119044,95.9413145 103.073495,92.4654999 103.863829,93.9146004 C104.964294,95.9311809 132.796062,128.095134 122.091536,127.608722 C111.427027,127.122311 107.525377,122.775009 107.525377,122.775009 C107.525377,122.775009 117.009387,176.574135 116.729269,185.805817 C115.878909,213.744071 77.7327801,217.098283 76.8924248,200.053617 C76.2021329,186.140225 78.4630889,157.219015 76.0820822,144.653388 C76.0820822,144.653388 69.5293115,115.499106 77.2125602,109.72297 Z",
    id: "Path",
    fill: "#93CE64"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.9704915,95.7690438 C95.9704915,95.7690438 92.4990237,97.3600144 89.1075897,96.4885273 C89.1075897,96.4885273 88.9375178,98.241635 86.9166633,101.474244 C86.9166633,101.474244 86.7365872,101.595847 86.466473,101.778251 C91.8487487,105.608741 94.4398443,110.493122 95.8104238,109.702703 C97.2610372,108.861617 96.0205127,98.6368443 96.0205127,98.6368443 C95.3102123,97.7754908 95.9704915,95.7690438 95.9704915,95.7690438 Z",
    id: "Path",
    fill: "#003DCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.7419383,151.371945 C76.9724586,148.423076 76.8624121,150.926068 79.903698,153.033851 C80.3939053,153.368258 84.2655423,154.553886 87.4168748,154.837626 C90.5682073,155.121366 88.9775347,160.299621 83.8253562,160.72523 C78.6631735,161.15084 78.6531693,159.063325 76.3922133,157.9993 C73.420957,156.600867 75.7419383,151.371945 75.7419383,151.371945 Z",
    id: "Path",
    fill: "#FFBB83"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.6321147,110.9998 C76.4020174,111.232872 76.1919286,111.476078 75.991844,111.749684 L73.4807823,122.369666 C73.4007484,132.48297 76.0818821,144.400048 76.0818821,144.400048 C76.4120217,146.143023 81.9443609,133.19232 83.0948473,126.767636 C84.8756003,116.725268 81.6842509,114.647886 76.6321147,110.9998 Z",
    id: "Path",
    fill: "#93CE64"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.6822359,110.847797 C62.4762292,127.122311 49.4807344,143.396825 59.3449052,152.425836 C64.8672402,157.482488 76.1920286,159.438267 77.4425574,158.151304 C80.553873,154.949095 77.4325532,152.283966 77.4325532,152.283966 C77.4325532,152.283966 68.9789788,147.04491 68.9789788,143.792034 C68.9789788,142.444269 77.3525193,128.155935 78.6730777,126.048152 C85.686043,114.901225 76.6822359,110.847797 76.6822359,110.847797 Z",
    id: "Path",
    fill: "#93CE64"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBankCheck);
export default __webpack_public_path__ + "static/media/bank-check.61b3dccc194a6d44baf4eebc8debf599.svg";
export { ForwardRef as ReactComponent };